define.alias("ember-cli-clipboard/modifiers/clipboard", "calendar/modifiers/clipboard");